import React,{Fragment, Component} from 'react';
import {Link} from 'react-router-dom';
import Header from './../Layout/Header';
import FooterPremium from './../Layout/FooterPremium';
import PageTitle from './../Layout/PageTitle';
import bgimg from './../../images/bg-view.png';

class PrivacyPolicy extends Component{
	
	render(){
		return(
			<Fragment>
				<Header />	
				<div className="page-content bg-white">
					{/*  banner  */}
					<PageTitle motherMenu="Privacy Policy" activeMenu="Privacy Policy" />
					<section className="content-inner-2">				
						<div className="container">
							<div className="row">
								<div className="col-lg-8 col-md-7 col-sm-12">
									<div className="dlab-page-text sidebar">
										<h3 className="title">Privacy Policy</h3>
										<p className="font-18">This Privacy Policy describes how Star Giga ("we", "our", or "us") collects, uses, and protects your personal information when you visit our website or use our services. By using our website, you agree to the collection and use of information in accordance with this policy.</p>
										<div className="dlab-divider bg-gray-dark"></div>
										<h3 className="title">Information We Collect</h3>
										<p className="font-18">We may collect the following types of information:</p>
										<ul className="list-circle primary m-a0">
											<li><strong>Personal Information:</strong> Name, email address, phone number, and other contact details you provide when contacting us or requesting information about our properties.</li>
											<li><strong>Usage Data:</strong> Information about how you access and use our website, including your IP address, browser type, pages visited, and time spent on our site.</li>
											<li><strong>Cookies:</strong> We use cookies and similar tracking technologies to track activity on our website and hold certain information to improve your browsing experience.</li>
											<li><strong>Property Inquiries:</strong> Information you provide when expressing interest in our properties, including property preferences, budget, and investment goals.</li>
										</ul>
										<div className="dlab-divider bg-gray-dark"></div>
										<h3 className="title">How We Use Your Information</h3>
										<p className="font-18">We use the collected information for various purposes:</p>
										<ul className="list-circle primary m-a0">
											<li>To provide and maintain our services</li>
											<li>To notify you about changes to our services or properties</li>
											<li>To respond to your inquiries and provide customer support</li>
											<li>To send you marketing communications about our properties and services (with your consent)</li>
											<li>To analyze and improve our website and services</li>
											<li>To comply with legal obligations</li>
										</ul>
										<div className="dlab-divider bg-gray-dark"></div>
										<h3 className="title">Data Security</h3>
										<p className="font-18">We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure.</p>
										<div className="dlab-divider bg-gray-dark"></div>
										<h3 className="title">Sharing Your Information</h3>
										<p className="font-18">We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:</p>
										<ul className="list-circle primary m-a0">
											<li>With service providers who assist us in operating our website and conducting our business</li>
											<li>When required by law or to protect our rights and safety</li>
											<li>With your explicit consent</li>
										</ul>
										<div className="dlab-divider bg-gray-dark"></div>
										<h3 className="title">Your Rights</h3>
										<p className="font-18">You have the right to:</p>
										<ul className="list-circle primary m-a0">
											<li>Access and receive a copy of your personal data</li>
											<li>Request correction of inaccurate personal information</li>
											<li>Request deletion of your personal information</li>
											<li>Object to processing of your personal information</li>
											<li>Withdraw consent at any time</li>
										</ul>
										<div className="dlab-divider bg-gray-dark"></div>
										<h3 className="title">Contact Us</h3>
										<p className="font-18">If you have any questions about this Privacy Policy or wish to exercise your rights, please <Link to={"/contact-us"}>contact us</Link> at info@stargiga.com.</p>
										<p className="font-18"><em>Last updated: January 2026</em></p>
									</div>
								</div>
								<div className="col-lg-4 col-md-5 col-sm-12">
									<aside className="sticky-top">
										<div className="list-group mb-5">
											<Link className="list-group-item" to={"/"}><i className="fa fa-home mr-2"></i>Home</Link>
											<Link className="list-group-item active" to={"/privacy-policy"}><i className="fa fa-lock mr-2"></i>Privacy Policy</Link>
											{/* <Link className="list-group-item" to={"/blog-grid"}><i className="fa fa-rss mr-2"></i>Blog</Link> */}
											<Link className="list-group-item" to={"/contact-us"}><i className="fa fa-phone mr-2"></i>Contact Us</Link>
										</div>
										<ul className="contact-question">
											<li>
												<i className="fa fa-map-marker"></i>
												<h4 className="title">Address</h4>
												<p>Ajman, United Arab Emirates</p>
											</li>
											<li>
												<i className="fa fa-envelope-o"></i>
												<h4 className="title">Email</h4>
												<p>info@stargiga.com</p>
											</li>
											<li>
												<i className="fa fa-phone"></i>
												<h4 className="title">Phone</h4>
												<p>+971-67-412-344</p>
											</li>
										</ul>
									</aside>
								</div>
							</div>
						</div>
					</section>
					
				</div>
				<FooterPremium />	
			</Fragment>
		)
	}
}
export default PrivacyPolicy;
